import Trx from './Trx';

export default Trx;
